<template>
    <div>
        <el-dialog
                title="Manage Data Sources"
                width="75%"
                :visible.sync="show_custom_data_source_dialog">
                  <manage-data-sources :extent_id="selected_extent"/>
        </el-dialog>
        <el-form :model="form" :rules="rules" ref="form">
        <!-- Need to set BOTH div el-upload dragger and it's parent div to 100%-->
            <el-form-item label="Data File" error="You must upload a data file." :show-message="error_no_upload">
        <el-upload
                id="data_file"
                drag
                :on-success="afterSuccessfulUpload"
                :on-remove="afterRemove"
                action="/api/uploads">
            <i class="el-icon-upload"></i>
            <div class="el-upload__text">Drop file here or <em>click to upload</em></div>
        </el-upload>
            </el-form-item>

            <el-form-item label="Data Source" prop="data_source_id" id="data_source">

            <el-select filterable v-model="form.data_source_id" placeholder="Select data source">
                <el-option
                    v-for="item in data_sources"
                    :key = "item.id"
                    :label = "item.source_name"
                    :value = "item.id">
                </el-option>
            </el-select>

            </el-form-item>
        <el-button type="primary" style="margin-top:20px" v-on:click="startImport" id="data_start" >Start Importing</el-button>
        <el-button @click="openDataSourceDialog" icon="el-icon-setting"></el-button>
        </el-form>
    </div>
</template>

<script>
    import ElOption from "../../../../node_modules/element-ui/packages/select/src/option.vue";

    export default {
        props: ['selected_extent'],
        components: {ElOption},
        mounted() {
            // console.log('Component mounted now.')
            if (this.selected_extent) {
                this.loadExtent()
            } else {
                axios.get('/api/dataSources')
                    .then(response => {
                        this.data_sources = response.data
                        // console.log(this.data_sources)
                    })
                    .catch(error => {
                        console.log('oops cats')
                    })
            }
        },
        watch: {
            selected_extent: function(val) {
                this.loadExtent()
            }
        },
        data() {
            return {
                form: {
                    data_source_id: '',
                    upload_file: ''
                },
                rules: {
                    data_source_id: [
                        {required: true, message: 'Please select a data source.', trigger: 'change'}
                    ]
                },
                extents: '',
                data_sources: '',
                date_of_data: null,
                percentage: 0,
                error_no_upload: false,
                pickerOptions: {
                    disabledDate(time) {
                        return time.getTime() > Date.now();
                    },
                    shortcuts: [{
                        text: 'Today',
                        onClick(picker) {
                            picker.$emit('pick', new Date());
                        }
                    }, {
                        text: 'Yesterday',
                        onClick(picker) {
                            const date = new Date();
                            date.setTime(date.getTime() - 3600 * 1000 * 24);
                            picker.$emit('pick', date);
                        }
                    }, {
                        text: 'A week ago',
                        onClick(picker) {
                            const date = new Date();
                            date.setTime(date.getTime() - 3600 * 1000 * 24 * 7);
                            picker.$emit('pick', date);
                        }
                    }]
                },
                show_custom_data_source_dialog: false,
            }
        },
        methods: {
            newDataSource(dataSourceId) {
                this.loadExtent()
                this.form.data_source_id = dataSourceId
                this.show_custom_data_source_dialog = false
            },
            openDataSourceDialog() {
                this.show_custom_data_source_dialog = true
            },
            startImport() {

                let errors = false
                if (!this.form.upload_file) {
                    this.error_no_upload = true;
                    errors = true
                }
                this.$refs['form'].validate((valid) => {
                    if (!valid) {
                        errors = true
                    }
                });
                if (errors) {
                    return false;
                }
                // console.log("selected extent:")
                // console.log(this.selected_extent);
                // console.log("selected data source:")
                // console.log(this.selected_data_source);
                // console.log("uploaded file:")
                // console.log(this.upload_file)
                // console.log("date of data:")
                // console.log(this.date_of_data)
                axios.post('/api/jobChains', {
                    extent_id: this.selected_extent,
                    date_of_data: this.date_of_data,
                    data_source_id: this.form.data_source_id,
                    type: "import",
                    disk: "s3",
                    upload_file: this.form.upload_file
                }).then(response => {
                    // console.log(response)
//                    window.location.href = '/progress/'
                    // need to come back so that we pass the job chain to progress
                    window.location.href = '/progress/' + response.data.job_chain_id
                }).catch(error => {
                    let validation_errors = error.response.data.errors
                    if (validation_errors) {
                        if (validation_errors.hasOwnProperty('upload_file')) {
                            this.error_no_upload = true
                        }
                    } else {
                        console.log('oops problem starting import')
                        console.log(error.response)
                    }
                })
                //
            },
            handleCheckChangeParent(selected_extent) {
                // console.log("handling check change from child")
                // console.log("select extent id back in parent:")
                // console.log(selected_extent)
                this.selected_extent = selected_extent.id
            },
            afterSuccessfulUpload(response, file, fileList) {
                // console.log("successful upload")
                // console.log("response")
                // console.log(response)
                this.error_no_upload = false
                this.form.upload_file = response
            },
            afterRemove() {
                this.form.upload_file = ''
            },
            loadExtent() {
                axios.get('/api/dataSources/' + this.selected_extent)
                    .then(response => {
                        this.data_sources = response.data
                        // console.log(this.data_sources)
                    })
                    .catch(error => {
                        console.log('oops cats')
                    })
            }
        }
    }
</script>
